/**
 * Theme-related constants for the application
 * This follows the project standard of keeping constants in the constants directory
 */
export const THEME_CONSTANTS = {
  // Default theme for new users - fixed to light theme for all users
  // Light/dark mode will be a Plus feature in the future
  DEFAULT_THEME: 'light',
  
  // Storage key for theme preferences in localStorage and cookies
  STORAGE_KEY: 'meduler_theme',
  
  // Theme options available in the application
  // System option removed as auto-detection is disabled
  THEME_OPTIONS: ['light', 'dark'] as const,
  
  // Default transition timing for theme changes (in milliseconds)
  TRANSITION_MS: 150,
  
  // Cookie storage duration in days
  COOKIE_DAYS: 365
};
